import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CybersocXDRDashboardSearchCriteria } from 'src/app/shared/model/searchCriteria';
import { Utilities } from 'src/app/shared/utilities';
import { CybersocxdrglobalfiltersService } from '../../cybersocxdrglobalfilters.service';
import { generateHightchartPdf } from '../../utils';
import { ContextService } from 'src/app/shared/services/context-service';

@Component({
  selector: 'app-incidentform',
  templateUrl: './incidentform.component.html',
  styleUrls: ['./incidentform.component.scss'],
})
export class IncidentformComponent implements OnInit {
  @Output() searchEmitter = new EventEmitter<CybersocXDRDashboardSearchCriteria>(true);
  @Output() searchEmitterSingleCase = new EventEmitter<object>(true);
  @Input() handlePdfExport = true;
  @Input() handleAdvSearch = false;

  // search fields
  caseNumber: string;
  subject: string;

  advSearch = false;
  savedSearches = false;

  constructor(public globalFilters: CybersocxdrglobalfiltersService, private readonly context: ContextService) { }

  async ngOnInit() {
    await this.globalFilters.init();
    if (!this.globalFilters.searchCriteria) {
      this.caseNumber = '';

      this.globalFilters.createdFrom = Utilities.getTodayMinusDays(7);
      this.globalFilters.createdTo = Utilities.getTodayMinusDays(0);
    }

    this.onCreatedPeriodChange();
    this.search();
  }

  onCreatedPeriodChange(): void {
    if (this.globalFilters.createdFrom) {
      this.globalFilters.searchCriteria.createdFrom = this.globalFilters.createdFrom;
      this.globalFilters.createdPeriod = undefined;
    }

    if (this.globalFilters.createdTo) {
      this.globalFilters.searchCriteria.createdTo = this.globalFilters.createdTo;
    }

    // A change in the calendar has been done, clear the period so it can be re-selected
    this.globalFilters.createdPeriod = undefined;
  }

  /** Exposed function: Emit the search criteria. Let's hope the handler won't change its content. */
  search() {
    if (this.caseNumber && this.caseNumber.length > 0) {
      return this.searchEmitterSingleCase.emit({
        type: 'caseNumber',
        value: this.caseNumber,
      });
    }
    if (this.subject && this.subject.length > 0) {
      return this.searchEmitterSingleCase.emit({
        type: 'subject',
        value: this.subject,
      });
    }
    this.globalFilters.updateSearchCriteria();
    this.searchEmitter.emit(this.globalFilters.searchCriteria);
    this.globalFilters.serializeSeachCriteria();
  }

  /** Exposed function: Indirect exposition to the search criteria object. Technically leaking implementation details, not good. */

  /** Go back to the default search settings and emit a new search */
  reset() {
    delete this.globalFilters.createdFrom;
    delete this.globalFilters.createdTo;
    this.caseNumber = '';
    this.subject = '';
    this.globalFilters.reset();
    this.search();
  }

  /** Generate the highchart pdf */
  generatePdf() {
    generateHightchartPdf(
      this.globalFilters.searchCriteria.createdFrom,
      this.globalFilters.searchCriteria.createdTo,
      this.context.isDarkTheme(),
      {
        marginTop: 45,
        marginBottom: 2,
        marginLeft: 2,
        marginRight: 2,
        pages: [{ columns: [1, 1] }, { columns: [1, 1] }, { columns: [1, 5] }],
      }
    );
  }
}
